import './content-panel.css'

function ContentPanel(props) {
return(
<div className="content-panel">
<h3>{props.heading}</h3>
<p>{props.content}</p>
</div>)
}

export default ContentPanel;